<template>
    <div class="intelligence-chart intelligence-chart--constraints">
        <h3 class="intelligence-chart__title">{{ $t('pages.intelligence.charts.constraint_breakdown') }}</h3>
        <div v-if="hasData" class="intelligence-chart__body">
            <apexchart type="bar" height="280" :options="chartOptions" :series="series"></apexchart>
            <ul class="intelligence-chart__legend">
                <li v-for="item in legendItems" :key="item.reasonCode">{{ item.text }}</li>
            </ul>
        </div>
        <p v-else class="intelligence-chart__empty">{{ $t('pages.intelligence.overview.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            breakdown: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            hasData() {
                return this.breakdown.length > 0
            },

            topItems() {
                return this.breakdown.slice(0, 8)
            },

            series() {
                return [
                    {
                        name: this.$t('pages.intelligence.constraints.table.frequency'),
                        data: this.topItems.map((item) => item.count),
                    },
                ]
            },

            legendItems() {
                return this.topItems.map((item) => ({
                    reasonCode: item.reasonCode,
                    text: this.$t('pages.intelligence.charts.constraint_share', {
                        label: this.reasonLabel(item.reasonCode),
                        count: item.count,
                        percent: item.percent,
                    }),
                }))
            },

            chartOptions() {
                return {
                    chart: {
                        type: 'bar',
                        toolbar: { show: false },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            columnWidth: '55%',
                        },
                    },
                    colors: ['#ef4444'],
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: false,
                    },
                    xaxis: {
                        categories: this.topItems.map((item) => this.reasonLabel(item.reasonCode)),
                        labels: {
                            rotate: -35,
                            trim: true,
                            style: {
                                fontSize: '11px',
                            },
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => Math.round(value),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => value,
                        },
                    },
                    grid: {
                        borderColor: '#e5e7eb',
                    },
                }
            },
        },

        methods: {
            reasonLabel(code) {
                if (!code) return this.$t('pages.intelligence.reasons.unknown')

                const headingKey = `pages.practice.create.reason_codes.${code}.heading`
                if (this.$te(headingKey)) return this.$t(headingKey)

                const intelKey = `pages.intelligence.reasons.${code}`
                if (this.$te(intelKey)) return this.$t(intelKey)

                return String(code)
                    .toLowerCase()
                    .split('_')
                    .filter(Boolean)
                    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                    .join(' ')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-chart {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-chart__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-chart__legend {
        margin: 12px 0 0;
        padding-left: 18px;
        color: #6b7280;
        font-size: 13px;
    }

    .intelligence-chart__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
